/*
Unobtrusive JavaScript
https://github.com/rails/rails/blob/main/actionview/app/javascript
Released under the MIT license
 */
var linkClickSelector = "a[data-confirm], a[data-method], a[data-remote]:not([disabled]), a[data-disable-with], a[data-disable]";
var buttonClickSelector = {
  selector: "button[data-remote]:not([form]), button[data-confirm]:not([form])",
  exclude: "form button"
};
var inputChangeSelector = "select[data-remote], input[data-remote], textarea[data-remote]";
var formSubmitSelector = "form:not([data-turbo=true])";
var formInputClickSelector = "form:not([data-turbo=true]) input[type=submit], form:not([data-turbo=true]) input[type=image], form:not([data-turbo=true]) button[type=submit], form:not([data-turbo=true]) button:not([type]), input[type=submit][form], input[type=image][form], button[type=submit][form], button[form]:not([type])";
var formDisableSelector = "input[data-disable-with]:enabled, button[data-disable-with]:enabled, textarea[data-disable-with]:enabled, input[data-disable]:enabled, button[data-disable]:enabled, textarea[data-disable]:enabled";
var formEnableSelector = "input[data-disable-with]:disabled, button[data-disable-with]:disabled, textarea[data-disable-with]:disabled, input[data-disable]:disabled, button[data-disable]:disabled, textarea[data-disable]:disabled";
var fileInputSelector = "input[name][type=file]:not([disabled])";
var linkDisableSelector = "a[data-disable-with], a[data-disable]";
var buttonDisableSelector = "button[data-remote][data-disable-with], button[data-remote][data-disable]";
var nonce = null;

var loadCSPNonce = function loadCSPNonce() {
  var metaTag = document.querySelector("meta[name=csp-nonce]");
  return nonce = metaTag && metaTag.content;
};

var cspNonce = function cspNonce() {
  return nonce || loadCSPNonce();
};

var m = Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector;

var matches = function matches(element, selector) {
  if (selector.exclude) {
    return m.call(element, selector.selector) && !m.call(element, selector.exclude);
  } else {
    return m.call(element, selector);
  }
};

var EXPANDO = "_ujsData";

var getData = function getData(element, key) {
  return element[EXPANDO] ? element[EXPANDO][key] : undefined;
};

var setData = function setData(element, key, value) {
  if (!element[EXPANDO]) {
    element[EXPANDO] = {};
  }

  return element[EXPANDO][key] = value;
};

var $ = function $(selector) {
  return Array.prototype.slice.call(document.querySelectorAll(selector));
};

var isContentEditable = function isContentEditable(element) {
  var isEditable = false;

  do {
    if (element.isContentEditable) {
      isEditable = true;
      break;
    }

    element = element.parentElement;
  } while (element);

  return isEditable;
};

var csrfToken = function csrfToken() {
  var meta = document.querySelector("meta[name=csrf-token]");
  return meta && meta.content;
};

var csrfParam = function csrfParam() {
  var meta = document.querySelector("meta[name=csrf-param]");
  return meta && meta.content;
};

var CSRFProtection = function CSRFProtection(xhr) {
  var token = csrfToken();

  if (token) {
    return xhr.setRequestHeader("X-CSRF-Token", token);
  }
};

var refreshCSRFTokens = function refreshCSRFTokens() {
  var token = csrfToken();
  var param = csrfParam();

  if (token && param) {
    return $('form input[name="' + param + '"]').forEach(function (input) {
      return input.value = token;
    });
  }
};

var AcceptHeaders = {
  "*": "*/*",
  text: "text/plain",
  html: "text/html",
  xml: "application/xml, text/xml",
  json: "application/json, text/javascript",
  script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
};

var ajax = function ajax(options) {
  options = prepareOptions(options);
  var xhr = createXHR(options, function () {
    var response = processResponse(xhr.response != null ? xhr.response : xhr.responseText, xhr.getResponseHeader("Content-Type"));

    if (Math.floor(xhr.status / 100) === 2) {
      if (typeof options.success === "function") {
        options.success(response, xhr.statusText, xhr);
      }
    } else {
      if (typeof options.error === "function") {
        options.error(response, xhr.statusText, xhr);
      }
    }

    return typeof options.complete === "function" ? options.complete(xhr, xhr.statusText) : undefined;
  });

  if (options.beforeSend && !options.beforeSend(xhr, options)) {
    return false;
  }

  if (xhr.readyState === XMLHttpRequest.OPENED) {
    return xhr.send(options.data);
  }
};

var prepareOptions = function prepareOptions(options) {
  options.url = options.url || location.href;
  options.type = options.type.toUpperCase();

  if (options.type === "GET" && options.data) {
    if (options.url.indexOf("?") < 0) {
      options.url += "?" + options.data;
    } else {
      options.url += "&" + options.data;
    }
  }

  if (!(options.dataType in AcceptHeaders)) {
    options.dataType = "*";
  }

  options.accept = AcceptHeaders[options.dataType];

  if (options.dataType !== "*") {
    options.accept += ", */*; q=0.01";
  }

  return options;
};

var createXHR = function createXHR(options, done) {
  var xhr = new XMLHttpRequest();
  xhr.open(options.type, options.url, true);
  xhr.setRequestHeader("Accept", options.accept);

  if (typeof options.data === "string") {
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
  }

  if (!options.crossDomain) {
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    CSRFProtection(xhr);
  }

  xhr.withCredentials = !!options.withCredentials;

  xhr.onreadystatechange = function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      return done(xhr);
    }
  };

  return xhr;
};

var processResponse = function processResponse(response, type) {
  if (typeof response === "string" && typeof type === "string") {
    if (type.match(/\bjson\b/)) {
      try {
        response = JSON.parse(response);
      } catch (error) {}
    } else if (type.match(/\b(?:java|ecma)script\b/)) {
      var script = document.createElement("script");
      script.setAttribute("nonce", cspNonce());
      script.text = response;
      document.head.appendChild(script).parentNode.removeChild(script);
    } else if (type.match(/\b(xml|html|svg)\b/)) {
      var parser = new DOMParser();
      type = type.replace(/;.+/, "");

      try {
        response = parser.parseFromString(response, type);
      } catch (error1) {}
    }
  }

  return response;
};

var href = function href(element) {
  return element.href;
};

var isCrossDomain = function isCrossDomain(url) {
  var originAnchor = document.createElement("a");
  originAnchor.href = location.href;
  var urlAnchor = document.createElement("a");

  try {
    urlAnchor.href = url;
    return !((!urlAnchor.protocol || urlAnchor.protocol === ":") && !urlAnchor.host || originAnchor.protocol + "//" + originAnchor.host === urlAnchor.protocol + "//" + urlAnchor.host);
  } catch (e) {
    return true;
  }
};

var preventDefault;
var _window = window,
    CustomEvent = _window.CustomEvent;

if (typeof CustomEvent !== "function") {
  CustomEvent = function CustomEvent(event, params) {
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;
  preventDefault = CustomEvent.prototype.preventDefault;

  CustomEvent.prototype.preventDefault = function () {
    var result = preventDefault.call(this);

    if (this.cancelable && !this.defaultPrevented) {
      Object.defineProperty(this, "defaultPrevented", {
        get: function get() {
          return true;
        }
      });
    }

    return result;
  };
}

var fire = function fire(obj, name, data) {
  var event = new CustomEvent(name, {
    bubbles: true,
    cancelable: true,
    detail: data
  });
  obj.dispatchEvent(event);
  return !event.defaultPrevented;
};

var stopEverything = function stopEverything(e) {
  fire(e.target, "ujs:everythingStopped");
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
};

var delegate = function delegate(element, selector, eventType, handler) {
  return element.addEventListener(eventType, function (e) {
    var target = e.target;

    while (!!(target instanceof Element) && !matches(target, selector)) {
      target = target.parentNode;
    }

    if (target instanceof Element && handler.call(target, e) === false) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
};

var toArray = function toArray(e) {
  return Array.prototype.slice.call(e);
};

var serializeElement = function serializeElement(element, additionalParam) {
  var inputs = [element];

  if (matches(element, "form")) {
    inputs = toArray(element.elements);
  }

  var params = [];
  inputs.forEach(function (input) {
    if (!input.name || input.disabled) {
      return;
    }

    if (matches(input, "fieldset[disabled] *")) {
      return;
    }

    if (matches(input, "select")) {
      toArray(input.options).forEach(function (option) {
        if (option.selected) {
          params.push({
            name: input.name,
            value: option.value
          });
        }
      });
    } else if (input.checked || ["radio", "checkbox", "submit"].indexOf(input.type) === -1) {
      params.push({
        name: input.name,
        value: input.value
      });
    }
  });

  if (additionalParam) {
    params.push(additionalParam);
  }

  return params.map(function (param) {
    if (param.name) {
      return "".concat(encodeURIComponent(param.name), "=").concat(encodeURIComponent(param.value));
    } else {
      return param;
    }
  }).join("&");
};

var formElements = function formElements(form, selector) {
  if (matches(form, "form")) {
    return toArray(form.elements).filter(function (el) {
      return matches(el, selector);
    });
  } else {
    return toArray(form.querySelectorAll(selector));
  }
};

var handleConfirmWithRails = function handleConfirmWithRails(rails) {
  return function (e) {
    if (!allowAction(this, rails)) {
      stopEverything(e);
    }
  };
};

var confirm = function confirm(message, element) {
  return window.confirm(message);
};

var allowAction = function allowAction(element, rails) {
  var callback;
  var message = element.getAttribute("data-confirm");

  if (!message) {
    return true;
  }

  var answer = false;

  if (fire(element, "confirm")) {
    try {
      answer = rails.confirm(message, element);
    } catch (error) {}

    callback = fire(element, "confirm:complete", [answer]);
  }

  return answer && callback;
};

var handleDisabledElement = function handleDisabledElement(e) {
  var element = this;

  if (element.disabled) {
    stopEverything(e);
  }
};

var enableElement = function enableElement(e) {
  var element;

  if (e instanceof Event) {
    if (isXhrRedirect(e)) {
      return;
    }

    element = e.target;
  } else {
    element = e;
  }

  if (isContentEditable(element)) {
    return;
  }

  if (matches(element, linkDisableSelector)) {
    return enableLinkElement(element);
  } else if (matches(element, buttonDisableSelector) || matches(element, formEnableSelector)) {
    return enableFormElement(element);
  } else if (matches(element, formSubmitSelector)) {
    return enableFormElements(element);
  }
};

var disableElement = function disableElement(e) {
  var element = e instanceof Event ? e.target : e;

  if (isContentEditable(element)) {
    return;
  }

  if (matches(element, linkDisableSelector)) {
    return disableLinkElement(element);
  } else if (matches(element, buttonDisableSelector) || matches(element, formDisableSelector)) {
    return disableFormElement(element);
  } else if (matches(element, formSubmitSelector)) {
    return disableFormElements(element);
  }
};

var disableLinkElement = function disableLinkElement(element) {
  if (getData(element, "ujs:disabled")) {
    return;
  }

  var replacement = element.getAttribute("data-disable-with");

  if (replacement != null) {
    setData(element, "ujs:enable-with", element.innerHTML);
    element.innerHTML = replacement;
  }

  element.addEventListener("click", stopEverything);
  return setData(element, "ujs:disabled", true);
};

var enableLinkElement = function enableLinkElement(element) {
  var originalText = getData(element, "ujs:enable-with");

  if (originalText != null) {
    element.innerHTML = originalText;
    setData(element, "ujs:enable-with", null);
  }

  element.removeEventListener("click", stopEverything);
  return setData(element, "ujs:disabled", null);
};

var disableFormElements = function disableFormElements(form) {
  return formElements(form, formDisableSelector).forEach(disableFormElement);
};

var disableFormElement = function disableFormElement(element) {
  if (getData(element, "ujs:disabled")) {
    return;
  }

  var replacement = element.getAttribute("data-disable-with");

  if (replacement != null) {
    if (matches(element, "button")) {
      setData(element, "ujs:enable-with", element.innerHTML);
      element.innerHTML = replacement;
    } else {
      setData(element, "ujs:enable-with", element.value);
      element.value = replacement;
    }
  }

  element.disabled = true;
  return setData(element, "ujs:disabled", true);
};

var enableFormElements = function enableFormElements(form) {
  return formElements(form, formEnableSelector).forEach(function (element) {
    return enableFormElement(element);
  });
};

var enableFormElement = function enableFormElement(element) {
  var originalText = getData(element, "ujs:enable-with");

  if (originalText != null) {
    if (matches(element, "button")) {
      element.innerHTML = originalText;
    } else {
      element.value = originalText;
    }

    setData(element, "ujs:enable-with", null);
  }

  element.disabled = false;
  return setData(element, "ujs:disabled", null);
};

var isXhrRedirect = function isXhrRedirect(event) {
  var xhr = event.detail ? event.detail[0] : undefined;
  return xhr && xhr.getResponseHeader("X-Xhr-Redirect");
};

var handleMethodWithRails = function handleMethodWithRails(rails) {
  return function (e) {
    var link = this;
    var method = link.getAttribute("data-method");

    if (!method) {
      return;
    }

    if (isContentEditable(this)) {
      return;
    }

    var href = rails.href(link);
    var csrfToken$1 = csrfToken();
    var csrfParam$1 = csrfParam();
    var form = document.createElement("form");
    var formContent = "<input name='_method' value='".concat(method, "' type='hidden' />");

    if (csrfParam$1 && csrfToken$1 && !isCrossDomain(href)) {
      formContent += "<input name='".concat(csrfParam$1, "' value='").concat(csrfToken$1, "' type='hidden' />");
    }

    formContent += '<input type="submit" />';
    form.method = "post";
    form.action = href;
    form.target = link.target;
    form.innerHTML = formContent;
    form.style.display = "none";
    document.body.appendChild(form);
    form.querySelector('[type="submit"]').click();
    stopEverything(e);
  };
};

var isRemote = function isRemote(element) {
  var value = element.getAttribute("data-remote");
  return value != null && value !== "false";
};

var handleRemoteWithRails = function handleRemoteWithRails(rails) {
  return function (e) {
    var data, method, url;
    var element = this;

    if (!isRemote(element)) {
      return true;
    }

    if (!fire(element, "ajax:before")) {
      fire(element, "ajax:stopped");
      return false;
    }

    if (isContentEditable(element)) {
      fire(element, "ajax:stopped");
      return false;
    }

    var withCredentials = element.getAttribute("data-with-credentials");
    var dataType = element.getAttribute("data-type") || "script";

    if (matches(element, formSubmitSelector)) {
      var button = getData(element, "ujs:submit-button");
      method = getData(element, "ujs:submit-button-formmethod") || element.getAttribute("method") || "get";
      url = getData(element, "ujs:submit-button-formaction") || element.getAttribute("action") || location.href;

      if (method.toUpperCase() === "GET") {
        url = url.replace(/\?.*$/, "");
      }

      if (element.enctype === "multipart/form-data") {
        data = new FormData(element);

        if (button != null) {
          data.append(button.name, button.value);
        }
      } else {
        data = serializeElement(element, button);
      }

      setData(element, "ujs:submit-button", null);
      setData(element, "ujs:submit-button-formmethod", null);
      setData(element, "ujs:submit-button-formaction", null);
    } else if (matches(element, buttonClickSelector) || matches(element, inputChangeSelector)) {
      method = element.getAttribute("data-method");
      url = element.getAttribute("data-url");
      data = serializeElement(element, element.getAttribute("data-params"));
    } else {
      method = element.getAttribute("data-method");
      url = rails.href(element);
      data = element.getAttribute("data-params");
    }

    ajax({
      type: method || "GET",
      url: url,
      data: data,
      dataType: dataType,
      beforeSend: function beforeSend(xhr, options) {
        if (fire(element, "ajax:beforeSend", [xhr, options])) {
          return fire(element, "ajax:send", [xhr]);
        } else {
          fire(element, "ajax:stopped");
          return false;
        }
      },
      success: function success() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return fire(element, "ajax:success", args);
      },
      error: function error() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return fire(element, "ajax:error", args);
      },
      complete: function complete() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return fire(element, "ajax:complete", args);
      },
      crossDomain: isCrossDomain(url),
      withCredentials: withCredentials != null && withCredentials !== "false"
    });
    stopEverything(e);
  };
};

var formSubmitButtonClick = function formSubmitButtonClick(e) {
  var button = this;
  var form = button.form;

  if (!form) {
    return;
  }

  if (button.name) {
    setData(form, "ujs:submit-button", {
      name: button.name,
      value: button.value
    });
  }

  setData(form, "ujs:formnovalidate-button", button.formNoValidate);
  setData(form, "ujs:submit-button-formaction", button.getAttribute("formaction"));
  return setData(form, "ujs:submit-button-formmethod", button.getAttribute("formmethod"));
};

var preventInsignificantClick = function preventInsignificantClick(e) {
  var link = this;
  var method = (link.getAttribute("data-method") || "GET").toUpperCase();
  var data = link.getAttribute("data-params");
  var metaClick = e.metaKey || e.ctrlKey;
  var insignificantMetaClick = metaClick && method === "GET" && !data;
  var nonPrimaryMouseClick = e.button != null && e.button !== 0;

  if (nonPrimaryMouseClick || insignificantMetaClick) {
    e.stopImmediatePropagation();
  }
};

var Rails = {
  $: $,
  ajax: ajax,
  buttonClickSelector: buttonClickSelector,
  buttonDisableSelector: buttonDisableSelector,
  confirm: confirm,
  cspNonce: cspNonce,
  csrfToken: csrfToken,
  csrfParam: csrfParam,
  CSRFProtection: CSRFProtection,
  delegate: delegate,
  disableElement: disableElement,
  enableElement: enableElement,
  fileInputSelector: fileInputSelector,
  fire: fire,
  formElements: formElements,
  formEnableSelector: formEnableSelector,
  formDisableSelector: formDisableSelector,
  formInputClickSelector: formInputClickSelector,
  formSubmitButtonClick: formSubmitButtonClick,
  formSubmitSelector: formSubmitSelector,
  getData: getData,
  handleDisabledElement: handleDisabledElement,
  href: href,
  inputChangeSelector: inputChangeSelector,
  isCrossDomain: isCrossDomain,
  linkClickSelector: linkClickSelector,
  linkDisableSelector: linkDisableSelector,
  loadCSPNonce: loadCSPNonce,
  matches: matches,
  preventInsignificantClick: preventInsignificantClick,
  refreshCSRFTokens: refreshCSRFTokens,
  serializeElement: serializeElement,
  setData: setData,
  stopEverything: stopEverything
};
var handleConfirm = handleConfirmWithRails(Rails);
Rails.handleConfirm = handleConfirm;
var handleMethod = handleMethodWithRails(Rails);
Rails.handleMethod = handleMethod;
var handleRemote = handleRemoteWithRails(Rails);
Rails.handleRemote = handleRemote;

var start = function start() {
  if (window._rails_loaded) {
    throw new Error("rails-ujs has already been loaded!");
  }

  window.addEventListener("pageshow", function () {
    $(formEnableSelector).forEach(function (el) {
      if (getData(el, "ujs:disabled")) {
        enableElement(el);
      }
    });
    $(linkDisableSelector).forEach(function (el) {
      if (getData(el, "ujs:disabled")) {
        enableElement(el);
      }
    });
  });
  delegate(document, linkDisableSelector, "ajax:complete", enableElement);
  delegate(document, linkDisableSelector, "ajax:stopped", enableElement);
  delegate(document, buttonDisableSelector, "ajax:complete", enableElement);
  delegate(document, buttonDisableSelector, "ajax:stopped", enableElement);
  delegate(document, linkClickSelector, "click", preventInsignificantClick);
  delegate(document, linkClickSelector, "click", handleDisabledElement);
  delegate(document, linkClickSelector, "click", handleConfirm);
  delegate(document, linkClickSelector, "click", disableElement);
  delegate(document, linkClickSelector, "click", handleRemote);
  delegate(document, linkClickSelector, "click", handleMethod);
  delegate(document, buttonClickSelector, "click", preventInsignificantClick);
  delegate(document, buttonClickSelector, "click", handleDisabledElement);
  delegate(document, buttonClickSelector, "click", handleConfirm);
  delegate(document, buttonClickSelector, "click", disableElement);
  delegate(document, buttonClickSelector, "click", handleRemote);
  delegate(document, inputChangeSelector, "change", handleDisabledElement);
  delegate(document, inputChangeSelector, "change", handleConfirm);
  delegate(document, inputChangeSelector, "change", handleRemote);
  delegate(document, formSubmitSelector, "submit", handleDisabledElement);
  delegate(document, formSubmitSelector, "submit", handleConfirm);
  delegate(document, formSubmitSelector, "submit", handleRemote);
  delegate(document, formSubmitSelector, "submit", function (e) {
    return setTimeout(function () {
      return disableElement(e);
    }, 13);
  });
  delegate(document, formSubmitSelector, "ajax:send", disableElement);
  delegate(document, formSubmitSelector, "ajax:complete", enableElement);
  delegate(document, formInputClickSelector, "click", preventInsignificantClick);
  delegate(document, formInputClickSelector, "click", handleDisabledElement);
  delegate(document, formInputClickSelector, "click", handleConfirm);
  delegate(document, formInputClickSelector, "click", formSubmitButtonClick);
  document.addEventListener("DOMContentLoaded", refreshCSRFTokens);
  document.addEventListener("DOMContentLoaded", loadCSPNonce);
  return window._rails_loaded = true;
};

Rails.start = start;

if (typeof jQuery !== "undefined" && jQuery && jQuery.ajax) {
  if (jQuery.rails) {
    throw new Error("If you load both jquery_ujs and rails-ujs, use rails-ujs only.");
  }

  jQuery.rails = Rails;
  jQuery.ajaxPrefilter(function (options, originalOptions, xhr) {
    if (!options.crossDomain) {
      return CSRFProtection(xhr);
    }
  });
}

export { Rails as default };